import { render, staticRenderFns } from "./TutoriaDetalleNotas.vue?vue&type=template&id=2e23c3a6&"
import script from "./TutoriaDetalleNotas.vue?vue&type=script&lang=js&"
export * from "./TutoriaDetalleNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports